<div class="support-login-container">
  <div *ngIf="isLoading" class="loading-state">
    <div class="loading-wrapper">
      <div class="bar-chart">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
      <div class="loading-text">{{ currentMessage }}</div>
    </div>
  </div>
</div>
